import { render, staticRenderFns } from "./SlsScI_List.vue?vue&type=template&id=051e26a3"
import script from "./SlsScI_List.vue?vue&type=script&lang=js"
export * from "./SlsScI_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports